import React from "react";
import { useNavigate } from "react-router-dom";
import '../styles/GameCard.css';
import defaultImage from '../assets/games-placeholder.png';

const GameCard = ({ title, image, thumbnail, category, gameUrl, id }) => {
  const navigate = useNavigate();
  const displayImage = image || thumbnail || defaultImage;

  const handleClick = () => {
    navigate(`/game/${id}`, { 
      state: { gameTitle: title }
    });
  };

  return (
    <div className="game-card" onClick={handleClick}>
      <div className="game-image-wrapper">
        <img 
          src={displayImage} 
          alt={title}
          className="game-image"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultImage;
          }}
        />
      </div>
      <div className="game-info">
        <h3 className="game-title">{title}</h3>
      </div>
    </div>
  );
};

export default GameCard;
